import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { buildLegacyStationConnectorPath, isValidObjectId } from './legacy-routing.util';

export const LegacyLocationConnectorRedirect = () => {
    const { stationId, connectorId } = useParams();
    const { search, hash } = useLocation();

    if (!isValidObjectId(stationId) || !isValidObjectId(connectorId)) {
        return <Navigate to="/" replace />;
    }

    return (
        <Navigate
            to={buildLegacyStationConnectorPath(stationId!, connectorId!, search, hash)}
            replace
        />
    );
};
